import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IndicatorProjectResponseDto } from '../dto/response/indicator-project-response.dto';
import indicatorProjectService from '../services/indicator-project.service';
import { IndicatorProjectSaveRequestDto } from '../dto/request/indicator-project-save-request.dto';
import { IndicatorProjectUpdateRequestDto } from '../dto/request/indicator-project-update-request.dto';
import { showError, showSuccess } from '../../../../utils/Notifications';

const initialState = {
  status: 'idle',
  indicatorProjects: [] as IndicatorProjectResponseDto[] | null,
  filteredIndicatorProjects: [] as IndicatorProjectResponseDto[] | null,
  indicatorProject: {} as IndicatorProjectResponseDto | null,
  error: null as string | null,
};

// export const fetchIndicatorProjectById = createAsyncThunk(
//   'indicatorProjects/fetchIndicatorProjectById',
//   async (id: string) => {
//     return await indicatorProjectService.fetchIndicatorProjectById(id);
//   }
// );

// export const fetchIndicatorProjectsByCompactIndicatorId = createAsyncThunk(
//   'indicatorProjects/fetchIndicatorProjectsByCompactIndicatorId',
//   async (compactIndicatorId: string) => {
//     return await indicatorProjectService.fetchIndicatorProjectsByCompactIndicatorId(
//       compactIndicatorId
//     );
//   }
// );

// export const fetchIndicatorProjectsByProjectId = createAsyncThunk(
//   'indicatorProjects/fetchIndicatorProjectsByProjectId',
//   async (projectId: string) => {
//     return await indicatorProjectService.fetchIndicatorProjectsByProjectId(
//       projectId
//     );
//   }
// );

export const saveIndicatorProject = createAsyncThunk(
  'indicatorProjects/saveIndicatorProject',
  async (saveRequest: IndicatorProjectSaveRequestDto) => {
    return await indicatorProjectService.saveIndicatorProject(saveRequest);
  }
);

export const updateIndicatorProject = createAsyncThunk(
  'indicatorProjects/updateIndicatorGoal',
  async (updateRequest: IndicatorProjectUpdateRequestDto) => {
    return await indicatorProjectService.updateIndicatorProject(updateRequest);
  }
);

export const deleteIndicatorProject = createAsyncThunk(
  'indicatorProjects/deleteIndicatorProject',
  async (id: string) => {
    return await indicatorProjectService.deleteIndicatorProject(id);
  }
);

const indicatorProjectSlice = createSlice({
  name: 'indicatorProjectSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // .addCase(fetchIndicatorProjectById.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchIndicatorProjectById.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.indicatorProject = action.payload;
      // })
      // .addCase(fetchIndicatorProjectById.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      // .addCase(fetchIndicatorProjectsByCompactIndicatorId.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(
      //   fetchIndicatorProjectsByCompactIndicatorId.fulfilled,
      //   (state, action) => {
      //     state.status = 'succeeded';
      //     state.filteredIndicatorProjects = action.payload;
      //   }
      // )
      // .addCase(
      //   fetchIndicatorProjectsByCompactIndicatorId.rejected,
      //   (state, action) => {
      //     state.status = 'failed';
      //     state.error = action.error?.message ?? null;
      //   }
      // )
      // .addCase(fetchIndicatorProjectsByProjectId.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchIndicatorProjectsByProjectId.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.filteredIndicatorProjects = action.payload;
      // })
      // .addCase(fetchIndicatorProjectsByProjectId.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(saveIndicatorProject.pending, (state) => {
        state.status = 'loading';
        showSuccess('Indicator project saved');
      })
      .addCase(saveIndicatorProject.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.indicatorProjects?.push(action.payload);
      })
      .addCase(saveIndicatorProject.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
        showError('Failed to save indicator project');
      })
      .addCase(updateIndicatorProject.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateIndicatorProject.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (state.indicatorProjects) {
          const indicatorProjectIndex = state.indicatorProjects.findIndex(
            (indicatorProject) => indicatorProject.id === action.payload.id
          );
          if (indicatorProjectIndex !== -1) {
            state.indicatorProjects[indicatorProjectIndex] = action.payload;
          }
        }
        showSuccess('Indicator project updated');
      })
      .addCase(updateIndicatorProject.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
        showError('Failed to update indicator project');
      })
      .addCase(deleteIndicatorProject.pending, (state) => {
        state.status = 'loading';
        showSuccess('Indicator project deleted');
      })
      .addCase(deleteIndicatorProject.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deleteIndicatorProject.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
        showError('Failed to delete indicator project');
      });
  },
});

export default indicatorProjectSlice.reducer;
